<div class="item_group">
    <span class="item_label">Available &nbsp;</span>
    <span class="item_value">{{data.AvailableFbastock || 0 | number: "1.0-2"}} </span>
</div>

<div class="item_group">
    <span class="item_label">Working &nbsp;</span>
    <span class="item_value">{{data.WorkingQty | number: "1.0-2"}} </span>
</div>

<div class="item_group total_group">
    <span class="item_label">Total &nbsp;</span>
    <span class="item_value"> {{total | number: "1.0-2"}} </span>
</div>